import { useState } from 'react';
import queryString from 'query-string';
import moment from 'moment-timezone';
import useStewardshipFilter from '@/pages/events/useStewardshipFilter';
import { PayloadStates } from '@lore/utils';
import { useConnect } from '@hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10 } = props;

  const [timestamp] = useState(moment().toISOString());
  const [expireTimestamp] = useState(moment().add(2, 'weeks').toISOString());
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('event.find', {
    where: {
      eager: {
        $where: {
          activityId: {
            $null: false
          },
          cancelled: false,
          completed: false,
          date: {
            $gte: timestamp,
            $lte: expireTimestamp
          },
          $or: stewardshipFilter
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    },
    exclude: function (model) {
      return model.state === PayloadStates.DELETED;
    }
  }, {
    keepPreviousData: true
  });
}